import moment, { ISO_8601 } from 'moment';
export const DATE_FORMATS = [
    'MM-DD-YYYY',
    'YYYY-MM-DD',
    'YYYY-MM-DD HH:mm:ss',
    'DD MMMM YYYY',
    'MM/DD/YYYY',
    ISO_8601
];
export const yyyymmdd = (date) => {
    // Add fault tolerance for invalid inputs.
    if (!date) {
        return '';
    }
    return moment(date, DATE_FORMATS).format('YYYY-MM-DD');
};
export const phone = (phone) => {
    const digits = phone.toString().replace(/[^0-9]+/g, '');
    const results = digits.match(/([0-9]{3})([0-9]{3})([0-9]{4})/);
    return results ? `(${results[1]}) ${results[2]}-${results[3]}` : 'N/A';
};
